<template>
  <div class="side-nav-bar">
    <div class="header">
      <h4 class="flex-row-align-center">
        <i class="material-icons mar-right-10">explore</i>
        <b>
          Locale
          <span class="fc-unselected">.ai</span>
        </b>
      </h4>
    </div>
    <router-link
      v-for="item in navItems"
      :key="item.id"
      :to="item.path"
      class="menu-item"
    >
      <i class="material-icons pad-7">{{ item.icon }}</i>
      <h4>{{ item.name }}</h4>
    </router-link>
    <div class="line" />
    <div class="menu-header">
      Analyses
    </div>
    <router-link
      v-for="item in analysesItems"
      :key="item.id"
      :to="item.path"
      class="menu-item"
    >
      <i class="material-icons pad-7">{{ item.icon }}</i>
      <h4>{{ item.name }}</h4>
    </router-link>

    <div class="line" />
    <div class="menu-header">
      Management
    </div>
    <router-link
      v-for="item in managementItems"
      :key="item.id"
      :to="item.path"
      class="menu-item"
    >
      <i class="material-icons pad-7">{{ item.icon }}</i>
      <h4>{{ item.name }}</h4>
    </router-link>
    <div class="flex-expand"></div>
    <div class="section-heading">
      <h4>Need Help?</h4>
      <p>support@locale.ai</p>
    </div>

    <div class="control-icons">
      <i class="material-icons icon-button" @click="toggleTheme()">{{
        dark_mode ? "wb_sunny" : "brightness_4"
      }}</i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dark_mode: false,
    navItems: [
      // {
      //   id: "summary",
      //   name: "Summary",
      //   path: "/summary",
      //   icon: "assignment"
      // },
      {
        id: "dashboards",
        name: "Consoles",
        path: "/dashboards",
        icon: "map",
      },
      // {
      //   id: "metrics",
      //   name: "Metrics",
      //   path: "/metrics",
      //   icon: "timeline"
      // },
      {
        id: "entities",
        name: "Entity Lookup",
        path: "/entities",
        icon: "device_hub",
      },
    ],
    analysesItems: [
      {
        id: "static_asset",
        name: "Static Asset Performance",
        path: "/analysis",
        icon: "fiber_smart_record",
      },
      // {
      //   id: "supply_demand",
      //   name: "Supply Demand Gap",
      //   path: "/analysis/supply_demand",
      //   icon: "compare_arrows",
      // },
    ],
    managementItems: [
      {
        id: "organisation",
        name: "Organisation",
        path: "/organisation",
        icon: "work",
      },
      {
        id: "settings",
        name: "Settings",
        path: "/settings",
        icon: "settings",
      },
    ],
  }),
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    toggleTheme() {
      if (this.dark_mode) {
        window.light();
        this.dark_mode = false;
      } else {
        window.dark();
        this.dark_mode = true;
      }
    },
  },
  mounted() {
    const theme = localStorage.getItem("theme");
    if (theme) {
      if (theme === "theme-dark") {
        this.dark_mode = true;
      } else {
        this.dark_mode = false;
      }
    } else {
      this.dark_mode = false;
    }
  },
};
</script>

<style lang="scss">
.side-nav-bar {
  z-index: 9999;
  border-right: 1px solid var(--border-color);
  background: var(--color-secondary);
  display: flex;
  flex-direction: column;

  .line {
    border-bottom: 1px solid var(--border-color);
    margin-top: 5px;
  }

  .sub-heading {
    margin: 0;
    padding: 10px 20px;
    font-weight: bold;
    font-size: 1em;
  }

  .control-icons {
    padding: 10px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid var(--border-color);

    i {
      font-size: 20px;
    }
  }

  .section-heading {
    display: flex;
    flex-direction: column;
    padding: 15px 30px;
    border-top: 1px solid var(--border-color);

    h4 {
      display: flex;
      align-items: center;
      font-weight: bold;

      i {
        margin-left: 15px;
      }

      &:hover {
        color: var(--color-primary);
      }
    }
    p {
      margin: 0;
      padding-top: 10px;
      opacity: 0.7;
    }
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 30px;
    color: var(--font-color);
    border-bottom: 1px solid var(--border-color);
    border-right: 0;
    height: 66px;
    padding: 0 20px;

    h4 {
      font-size: 1.2em;
      margin-left: 10px;
    }

    i {
      font-size: 20px;
      color: var(--font-color);
    }
  }

  .menu-header {
    padding: 10px 20px 0 20px;
    opacity: 0.5;
  }

  .menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    margin: 5px 0px 0px 5px;
    border-right: 3px solid var(--color-transparent);
    color: var(--font-color);
    opacity: 0.9;
    transition: 0.3s all ease-in-out;

    &:hover {
      opacity: 1;
      background-color: var(--border-color);
      border-radius: 7px 0 0 7px;
    }

    h4 {
      margin-left: 10px;
      transition: 0.2s all ease-in-out;
    }

    i {
      font-size: 20px;
      transition: 0.2s all ease-in-out;
    }

    &.set-active {
      border-right: 3px solid var(--color-primary);
      opacity: 1;
      background-color: var(--color-primary-light);
      border-radius: 7px 0 0 7px;

      h4 {
        color: var(--color-primary);
        /* font-weight: bold; */
      }
      i {
        color: var(--color-primary) !important;
      }
    }
  }
}
</style>
